module.exports = {"purchase":"Purchase","notAvailable":"Online Sales Ended","unlock":"Unlock","unlocked":"Unlocked"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/Flexpass/locales/en.json
// module id = 1136
// module chunks = 0